import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-question-paper',
  templateUrl: './question-paper.component.html',
  styleUrls: ['./question-paper.component.scss']
})
export class QuestionPaperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
